<template>
  <common-dialog
    ref="dialog"
    title="Order Complete"
    :width="60"
    ok-text="Save"
    :reset-inputs="resetInputs"
    :save-cb="saveComplete"
  >
    <template v-slot:content>
      <div style="min-height: 300px !important" v-loading="loadingData">
        <div class="error-msg msg" v-if="errorMsg !== ''">
          <el-alert :title="errorMsg" type="error" :closable="false" />
        </div>
        <div class="success-msg msg" v-if="successMsg !== ''">
          <el-alert :title="successMsg" type="success" :closable="false" />
        </div>
        <div class="f-r" style="margin-bottom: 10px">
          <div class="common-hint-list" style="width: 60%">
            <span> 1. Completed order can NOT be modified!</span>
            <span> 2. All Upcoming pallets will be DELETED! </span>
            <span> 3. InStock pallets will always be ready to ship! </span>
          </div>
          <div class="f-c-c-c" style="width: 40%">
            <div class="f-r" style="gap: 20px; font-size: 18px">
              <span class="title">{{ riiOrderNo }}</span>
              <span class="title">{{ orderType }}</span>
            </div>
            <div class="title">
              {{ upcommingPalletsCount }} Upcoming pallets!
            </div>
          </div>
        </div>
        <div class="order-basic-info">
          <basic-table
            :table-data="orderUpcomingPallets"
            :table-headers="OrderCompletePalletTableHeaders"
            :has-actions="false"
            :showPagination="false"
            :rowClassName="rowClassName"
            :stripe="!rowClassName"
            :summary="true"
          />
        </div>
      </div>
    </template>
  </common-dialog>
</template>
<script>
// components
import CommonDialog from '@/components/common/CommonDialog.vue'
import BasicTable from '@/components/common/BasicTable.vue'
// apis
import { completeOrder, detailOrder } from '@/api/order'
import { queryPallets } from '@/api/pallet'
// models
import {
  PalletStatus,
  OrderCompletePalletTableHeaders
} from '@/core/models/pallet'
import { TrueStatus } from '@/core/configs/types'

export default {
  name: 'CompleteOrder',
  props: {
    orderId: {
      type: String,
      required: true
    },
    cb: {
      type: Function,
      default: () => {}
    }
  },
  components: {
    CommonDialog,
    BasicTable
  },
  data() {
    return {
      OrderCompletePalletTableHeaders,
      loadingData: false,
      orderDetail: null,
      orderUpcomingPallets: {},
      errorMsg: '',
      successMsg: ''
    }
  },
  computed: {
    riiOrderNo() {
      return this.orderDetail?.riiOrderNo ?? ''
    },
    orderType() {
      return this.orderDetail?.type ?? ''
    },
    orderStatus() {
      return this.orderDetail?.status ?? ''
    },
    orderPallets() {
      return this.orderUpcomingPallets.records ?? []
    },
    upcommingPalletsCount() {
      return this.orderPallets.length
    },
    inShipUpcomingPalletsCount() {
      return this.orderPallets.filter(one => one.inShipment === true).length
    }
  },
  methods: {
    resetInputs() {},
    open() {
      this.$refs.dialog.open()
      this.loadOrderData()
    },
    rowClassName() {},
    // ---------------------- order related api ------------------------------
    async saveComplete(_, done, error) {
      // try to complete order
      this.loadingData = true
      let msg = ''
      completeOrder(this.orderId)
        .then(res => {
          if (res) {
            this.$message.success('Successfully complete order!')
            done()
            if (this.cb) this.cb()
          } else {
            msg = 'Failed complete order ' + res?.msg ?? ''
            error(msg)
          }
        })
        .catch(err => {
          msg = 'Failed complete order ' + err
          error(msg)
        })
        .finally(() => {
          this.loadingData = false
        })
    },
    async loadOrderData() {
      if (this.orderId) {
        this.loadingData = true
        const res = await detailOrder(this.orderId)
        if (res === null) {
          this.errorMsg = 'Failed to get Order information'
        } else {
          const upcomingPallets = await queryPallets({
            orderIds: [this.orderId],
            statusList: [PalletStatus.PalletUpcoming],
            inShipment: TrueStatus,
            size: -1
          })
          this.$set(this, 'orderUpcomingPallets', upcomingPallets)
          this.$set(this, 'orderDetail', res)
        }
        this.loadingData = false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/common.scss';
.common-hint-list {
  margin-bottom: 0;
  font-size: 15px;
}
.order-basic-info ::v-deep th {
  height: 10px !important;
}
.order-basic-info ::v-deep tr {
  height: 10px !important;
}

.title {
  font-size: 21px;
  font-weight: bold;
}
</style>
